function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m428.028 512c16.845 0 30.5-13.655 30.5-30.5v-383.977h-13.618c-10.443 0-18.909-8.466-18.909-18.909v-49.922l-14.078-25.952c-3.948-1.809-8.207-2.74-12.633-2.74h-262.117c-16.845 0-30.5 13.655-30.5 30.5v451c0 16.845 13.655 30.5 30.5 30.5z",
  fill: "#f4fbff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m444.45 97.523v383.977c0 16.844-13.655 30.5-30.5 30.5h64.996c16.845 0 30.5-13.655 30.5-30.5v-371.344c0-4.401-.951-8.703-2.74-12.633z",
  fill: "#e4f6ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m500.513 88.59-79.657-79.657c-2.608-2.608-5.64-4.695-8.933-6.193v75.874c0 10.443 8.466 18.909 18.909 18.909h75.874c-1.499-3.294-3.585-6.326-6.193-8.933z",
  fill: "#e28086"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m237.653 358.199h33.177v69.494h-33.177z",
  fill: "#4a80aa",
  transform: "matrix(.707 -.707 .707 .707 -203.39 294.867)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m365.373 465.827-70.242-70.242c-4.025-4.025-10.551-4.025-14.576 0l-23.675 23.675c-4.025 4.025-4.025 10.551 0 14.576l70.242 70.242c10.563 10.563 27.688 10.563 38.251 0 10.562-10.563 10.562-27.688 0-38.251z",
  fill: "#cc9675"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144.723,
  cy: 283.429,
  fill: "#bed8fb",
  r: 142.169
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144.723,
  cy: 283.429,
  fill: "#f4fbff",
  r: 111.36
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m168.56 335.382c-2.801-.352-4.908-2.725-4.92-5.548l-.108-25.684-39.242.165.108 25.684c.012 2.823-2.074 5.214-4.873 5.589 0 0-7.246 24.765 24.622 24.631 31.868-.133 24.413-24.837 24.413-24.837z",
  fill: "#ffcbbe"
}), /*#__PURE__*/React.createElement("path", {
  d: "m202.882 342.892c-8.991-3.958-25.966-6.462-34.321-7.511l-.05.062c-12.535 15.68-36.357 15.75-48.985.144-8.347 1.119-25.3 3.767-34.257 7.8-9.31 4.195-14.67 13.359-14.864 22.976 42.004 37.706 105.767 37.898 147.993.574.166-10.645-5.748-19.745-15.516-24.045z",
  fill: "#407093"
}))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m174.537 223.99c0-6.192-5.02-11.211-11.211-11.211h-37.296c-14.99 0-27.142 12.152-27.142 27.143v20.2l9.271 7.108h72.483l9.271-15.611v-12.63c0-6.192-5.019-11.211-11.211-11.211h-.378c-2.092-.001-3.787-1.696-3.787-3.788z",
  fill: "#4a80aa"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m189.912 251.618-17.786-1.668c-7.547-.708-15.12 1.05-21.585 5.009-5.511 3.376-11.849 5.162-18.312 5.162h-33.342v16.106c0 3.26 2.643 5.902 5.902 5.902 1.013 0 1.865.781 1.928 1.793 1.225 19.751 17.623 35.393 37.682 35.393 20.078 0 36.487-15.67 37.639-35.447.057-.981.88-1.739 1.863-1.739h.096c3.315 0 5.996-2.688 5.974-5.995-.059-8.886-.059-24.516-.059-24.516z",
  fill: "#ffddce"
})))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m459.315 208.31h-133.226c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h133.225c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.725 7.726z",
  fill: "#407093"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m459.315 254.888h-133.226c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h133.225c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.725 7.726z",
  fill: "#407093"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m459.315 301.465h-133.226c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h133.225c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.725 7.726z",
  fill: "#407093"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m392.702 348.043h-66.613c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h66.613c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z",
  fill: "#407093"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m317.198 97.523h-153.276c-4.91 0-8.891-3.98-8.891-8.891v-29.61c0-4.91 3.98-8.891 8.891-8.891h153.277c4.91 0 8.891 3.98 8.891 8.891v29.61c-.001 4.91-3.981 8.891-8.892 8.891z",
  fill: "#ffe07d"
})));

var SvgRole = function SvgRole(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRole, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/role.1843f6ad.svg";
export { ForwardRef as ReactComponent };